/* Goldelucks conversion upgrades - preview build. Progressive enhancement only: if anything here fails,
   the theme's original product page and cart keep working. */
(function () {
  'use strict';
  var CFG = window.GLCRO || {};
  var isMobile = function () { return window.matchMedia('(max-width: 767px)').matches; };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var visible = function (el) { return !!(el && el.offsetParent !== null); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  // $59, $59.50 (as the cart page)
  var money = function (cents) { var d = cents / 100; return '$' + (d % 1 ? d.toFixed(2) : d.toFixed(0)); };
  var parseMoney = function (t) { var m = String(t || '').replace(/,/g, '').match(/(\d+(?:\.\d+)?)/); return m ? parseFloat(m[1]) : null; };
  var track = function (name, detail) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, detail || {}); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, detail || {})); } catch (e) {}
  };
  var CLOCK = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';

  /* ---------------- Product page ---------------- */
  function initProduct() {
    var info = $('.tt-product-single-info') || document;
    var heroItem = null;
    $$('.pdp-tabs .tt-item').forEach(function (it) {
      var title = $('.tt-collapse-title', it);
      if (!title || !/explosion/i.test(title.textContent)) return;
      var radios = $$('input[type="radio"]', it);
      if (!radios.length) { it.style.display = 'none'; return; } // empty "Confetti Explosion Card" step
      if (!heroItem) heroItem = it;
    });

    // 1. Confetti hero card with labels and prices
    if (heroItem) {
      heroItem.classList.add('glc-hero');
      heroItem.id = heroItem.id || 'explosion';
      var gif = $('.hover_image img', heroItem);
      var media = gif ? (gif.getAttribute('data-src') || gif.getAttribute('src')) : CFG.confettiGif;
      var content = $('.tt-collapse-content', heroItem);
      var head = document.createElement('div');
      head.className = 'glc-hero__head';
      head.innerHTML = '<div class="glc-hero__media"><img src="' + esc(media) + '" alt="Confetti bursting out of a Goldelucks box" loading="lazy"><span class="glc-hero__play">Watch it pop</span></div>' +
        '<div><p class="glc-hero__kicker">Make it explode</p><p class="glc-hero__title">Add a confetti explosion</p>' +
        '<p class="glc-hero__copy">Lift the lid and confetti bursts out with your message. Add flying butterflies for an extra surprise.</p></div>';
      if (content) content.insertBefore(head, content.firstChild);
      $$('.values', heroItem).forEach(function (v) {
        var input = $('input[type="radio"]', v); if (!input) return;
        var tk = $('.toolkit', v);
        var raw = (tk && (tk.getAttribute('data-text') || tk.textContent)) || input.value;
        raw = raw.replace(/\s+/g, ' ').trim();
        var price = (raw.match(/\(\+\$(\d+(?:\.\d+)?)\)/) || [])[1];
        var name = raw.replace(/\(\+\$[^)]*\)/, '').replace(/^Add\s+/i, '').trim();
        // the free option: per-template "Included option label" (e.g. butterfly boxes: "4x Flying Butterflies")
        if (/standard|no confetti/i.test(raw)) { name = (window.GL3_TPL && GL3_TPL.included) || 'No confetti'; }
        var cap = document.createElement('span');
        cap.className = 'glc-cap';
        cap.innerHTML = '<b>' + esc(name) + '</b><em>' + (price ? '+$' + esc(price) : 'Included') + '</em>';
        v.appendChild(cap);
        v.setAttribute('data-glc-name', name);
        v.setAttribute('data-glc-price', price || '0');
      });
      // Fix: the "Upgrade Your Gift:" label didn't reset when switching back to Standard
      heroItem.addEventListener('change', function (e) {
        if (!e.target || e.target.type !== 'radio') return;
        var v = e.target.closest('.values');
        var label = $('.current_option_name_bf', heroItem);
        if (label && v) {
          var p = v.getAttribute('data-glc-price');
          label.textContent = v.getAttribute('data-glc-name') + (p && p !== '0' ? ' (+$' + p + ')' : '');
        }
        track('confetti_option_selected', { option: v ? v.getAttribute('data-glc-name') : e.target.value });
        setTimeout(updateTotal, 120);
      });
      if (location.hash === '#explosion') setTimeout(function () { heroItem.scrollIntoView({ behavior: 'smooth', block: 'center' }); heroItem.classList.add('glc-flash'); }, 600);
    }

    // 2. Compact box sizes: show 4, then "More sizes"
    var swRoot = $('.tt-swatches-container-js');
    if (swRoot) {
      var tries = 0;
      var compact = function () {
        var sw = swRoot.querySelector('ul.tt-options-swatch') || swRoot.querySelector('ul');
        var lis = sw ? $$(':scope > li', sw) : [];
        if (lis.length < 7) { if (++tries < 30 && lis.length === 0) setTimeout(compact, 250); return; }
        if (sw.getAttribute('data-glc-compact')) return;
        sw.setAttribute('data-glc-compact', '1');
        sw.classList.add('glc-sizes');
        lis.forEach(function (li, i) { if (i >= 4 && !li.querySelector('.active') && !li.classList.contains('active')) li.classList.add('glc-more-hidden'); });
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'glc-more-btn';
        btn.textContent = 'More sizes (' + (lis.length - 4) + ')';
        btn.addEventListener('click', function () {
          var open = sw.classList.toggle('glc-sizes--open');
          btn.textContent = open ? 'Fewer sizes' : 'More sizes (' + (lis.length - 4) + ')';
        });
        sw.parentNode.insertBefore(btn, sw.nextSibling);
      };
      compact();
    }

    // 3. 1PM cutoff under the price
    var priceBox = $('.tt-price', info);
    if (priceBox && !$('.glc-cutoff')) {
      var cut = document.createElement('div');
      cut.className = 'glc-cutoff';
      cut.innerHTML = CLOCK + '<span><b>Order by 1PM</b> for same-day delivery in Melbourne</span>';
      priceBox.parentNode.insertBefore(cut, priceBox.nextSibling);
    }

    // 4. Running total on the Add to cart button
    var atc = function () { return $$('.btn-addtocart', info).filter(visible)[0] || $$('.btn-addtocart').filter(visible)[0]; };
    var priceEl = $('.tt-price .new-price', info);
    function currentTotal() {
      var base = priceEl ? parseMoney(priceEl.textContent) : null;
      if (base == null) return null;
      // The theme already adds the upgrade to the displayed price on some templates; only add it when it hasn't.
      var sel = heroItem ? $('input[type="radio"]:checked', heroItem) : null;
      var up = sel ? parseFloat(sel.closest('.values').getAttribute('data-glc-price') || '0') : 0;
      var variantBase = priceEl ? parseMoney(priceEl.getAttribute('data-variant-price')) : null;
      if (variantBase != null && variantBase > 1000) variantBase = variantBase / 100; // stored in cents
      var qtyEl = $('.pdp-qty', info);
      var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
      // Butterfly "Add 4 photos +$20" (gl-v3-low.js): counted as soon as it's picked. The theme only
      // adds its $20 to the price once the uploads finish, so take whichever is more.
      var po = $('.g3-po'), photos = po && po.parentNode.__on ? 20 : 0;
      if (po && variantBase != null) return (variantBase + Math.max(base - variantBase, up + photos)) * qty;
      var already = variantBase != null && Math.abs(base - variantBase - up) < 0.01;
      return (already ? base : base + up) * qty;
    }
    function updateTotal() {
      var b = atc(); var t = currentTotal();
      if (b && t != null) b.setAttribute('data-glc-total', money(Math.round(t * 100)));
      var sb = $('.glc-sticky__btn'); if (sb && t != null) sb.setAttribute('data-glc-total', money(Math.round(t * 100)));
      var sm = $('.glc-sticky__meta');
      if (sm) {
        var s = $('.tt-swatches-container-js .active');
        var size = s ? (s.getAttribute('data-value') || '') : '';
        var sel = heroItem ? $('input[type="radio"]:checked', heroItem) : null;
        var conf = sel ? sel.closest('.values').getAttribute('data-glc-name') : '';
        sm.textContent = [size, conf && conf !== ((window.GL3_TPL && GL3_TPL.included) || 'No confetti') ? conf : ''].filter(Boolean).join(' · ') || 'Order by 1PM for same-day delivery';
      }
    }
    if (priceEl) new MutationObserver(updateTotal).observe(priceEl, { childList: true, characterData: true, subtree: true });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.plus-btn, .minus-btn, .tt-swatches-container-js, .tt-options-swatch, .g3-po')) setTimeout(function () { updateTotal(); updateMulti(); }, 150); });
    // the gl-v3 quantity stepper sets the field and fires input/change (no +/- button click)
    document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('.pdp-qty, input[name="quantity"]')) updateTotal(); });
    document.addEventListener('input', function (e) { if (e.target.matches && e.target.matches('.pdp-qty, input[name="quantity"]')) updateTotal(); });
    setTimeout(updateTotal, 400);

    // 5. Confetti nudge if the shopper adds to cart without choosing an explosion
    var nudged = false;
    document.addEventListener('click', function (e) {
      if (nudged || !heroItem) return;
      var b = e.target.closest && e.target.closest('.btn-addtocart');
      if (!b || !info.contains(b) && info !== document) return;
      var sel = $('input[type="radio"]:checked', heroItem);
      if (sel && !/standard/i.test(sel.value)) return;
      var confetti = $$('input[type="radio"]', heroItem).filter(function (r) { return /^confetti\d+$/i.test(r.value) || /confetti/i.test(r.value) && !/butterfl/i.test(r.value); })[0];
      if (!confetti) return;
      e.preventDefault(); e.stopImmediatePropagation();
      nudged = true;
      var price = confetti.closest('.values').getAttribute('data-glc-price') || '20';
      var m = document.createElement('div');
      m.className = 'glc-modal';
      m.innerHTML = '<div class="glc-modal__box" role="dialog" aria-modal="true" aria-label="Add a confetti explosion"><img src="' + esc(CFG.confettiGif) + '" alt="" loading="lazy">' +
        '<p class="glc-hero__title">Make it explode for $' + esc(price) + '?</p><p class="glc-hero__copy">Confetti bursts out when they open the box.</p>' +
        '<button type="button" class="glc-btn glc-btn--primary" data-a="yes">Add confetti +$' + esc(price) + '</button><button type="button" class="glc-btn glc-btn--ghost" data-a="no">No thanks, add to cart</button></div>';
      document.body.appendChild(m);
      track('confetti_nudge_shown', {});
      m.addEventListener('click', function (ev) {
        var a = ev.target.getAttribute && ev.target.getAttribute('data-a');
        if (!a && ev.target !== m) return;
        m.remove();
        if (a === 'yes') { confetti.click(); track('confetti_nudge_accepted', {}); setTimeout(function () { b.click(); }, 250); }
        else if (a === 'no') { track('confetti_nudge_declined', {}); b.click(); }
        else { nudged = false; }
      });
    }, true);

    // 6. Multi-address card + prompt when quantity is 2 or more
    var appLink = function () {
      var block = $$('.shopify-app-block').filter(function (el) { return /multiple recipients/i.test(el.textContent); })[0];
      return block ? (block.querySelector('a') || block.querySelector('button')) : null;
    };
    var atcWrap = (atc() || {}).closest ? atc().closest('.tt-row-custom-01, .addtocart_sec, form') : null;
    var card = document.createElement('div');
    card.className = 'glc-corp';
    card.innerHTML = '<span class="glc-corp__icon" aria-hidden="true"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#1F6FB2" stroke-width="2"><rect x="3" y="7" width="18" height="13" rx="2"/><path d="M9 7V5h6v2"/></svg></span>' +
      '<div><p class="glc-corp__title">Sending to a team or client list?</p><p class="glc-corp__copy">Send one order to multiple addresses in a single checkout. <button type="button" class="glc-link" data-a="multi">Choose multiple recipients</button></p></div>';
    if (atcWrap && atcWrap.parentNode) atcWrap.parentNode.insertBefore(card, atcWrap.nextSibling);
    card.addEventListener('click', function (e) {
      if (!e.target.getAttribute || e.target.getAttribute('data-a') !== 'multi') return;
      var l = appLink();
      track('multi_address_click', { source: 'product_card' });
      if (l) { l.click(); } else { location.href = CFG.corporateUrl; }
    });
    function updateMulti() {
      var q = $('.pdp-qty', info); var n = q ? parseInt(q.value, 10) || 1 : 1;
      var t = $('.glc-corp__title', card);
      if (n > 1) { card.classList.add('glc-corp--hot'); t.textContent = 'Sending these ' + n + ' to different people?'; }
      else { card.classList.remove('glc-corp--hot'); t.textContent = 'Sending to a team or client list?'; }
    }

    // 7. Mobile sticky Add to cart
    var sticky = document.createElement('div');
    sticky.className = 'glc-sticky';
    sticky.innerHTML = '<span class="glc-sticky__meta"></span><button type="button" class="glc-sticky__btn">Add to cart</button>';
    document.body.appendChild(sticky);
    sticky.querySelector('button').addEventListener('click', function () { var b = atc(); if (b) b.click(); });
    var watchBtn = atc();
    if (watchBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('glc-sticky--show', !en[0].isIntersecting && isMobile()); }, { threshold: 0 }).observe(watchBtn);
    }
    updateTotal();
  }

  /* ---------------- Cart drawer (all pages) ---------------- */
  var drawer;
  function buildDrawer() {
    drawer = document.createElement('div');
    drawer.className = 'glc-drawer';
    drawer.innerHTML = '<div class="glc-drawer__scrim" data-close></div><aside class="glc-drawer__panel" role="dialog" aria-modal="true" aria-label="Your cart"><div class="glc-drawer__body">Loading your cart...</div></aside>';
    document.body.appendChild(drawer);
    drawer.addEventListener('click', function (e) { if (e.target.hasAttribute('data-close') || (e.target.closest && e.target.closest('[data-close]'))) closeDrawer(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }
  // iOS ignores overflow:hidden for page scroll, so the body is pinned in place while the drawer is open
  var lockY = null;
  function lockPage() {
    if (lockY !== null) return;
    lockY = window.scrollY || 0;
    var b = document.body.style; b.position = 'fixed'; b.top = -lockY + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
    document.documentElement.classList.add('glc-lock');
  }
  function unlockPage() {
    document.documentElement.classList.remove('glc-lock');
    if (lockY === null) return;
    var b = document.body.style; b.position = b.top = b.left = b.right = b.width = '';
    window.scrollTo(0, lockY); lockY = null;
  }
  function closeDrawer() { if (drawer) drawer.classList.remove('glc-drawer--open'); unlockPage(); }
  function fmtDate(s) {
    var p = String(s || '').split('/'); if (p.length !== 3) return s;
    var d = new Date(+p[0], +p[1] - 1, +p[2]);
    return d.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' });
  }
  function openDrawer() {
    if (!drawer) buildDrawer();
    drawer.classList.add('glc-drawer--open');
    lockPage();
    track('cart_drawer_open', {});
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      // Gift Upgrade lines = the boxes that point at them (gl-addons.js)
      .then(function (c) { return window.GLA && GLA.syncUpgrades ? GLA.syncUpgrades(c).catch(function () { return c; }) : c; })
      .then(renderDrawer).catch(function () { location.href = '/cart'; });
  }
  function cartUrl() { return (window.GLV2 && GLV2.cartUrl) || '/cart'; }
  // Cart lines, same rules as the gl-v3 cart page (gl-v3-cart.js): hidden lines are the confetti /
  // butterfly upgrades (linked to a box by _extra_variant_id:), the printed card (shares the box's
  // _common_random_string), the butterfly photo fee and the delivery guarantee.
  var CONF = 40138856890430, PHOTOFEE = 39603053559870;
  var isGuarantee = function (i) { return /Delivery Guarantee/i.test(i.product_type || '') || i.handle === 'just-right-delivery'; };
  var isCard = function (i) { return /HIDEPRODUCT/i.test(i.product_type || '') && !!(i.properties || {})._common_random_string; };
  var isUpgrade = function (i) { return i.handle === 'on-variant-hidden-product' || i.handle === 'gift-upgrade-butterflies' || i.variant_id === CONF; };
  var isHidden = function (i) { return isUpgrade(i) || isGuarantee(i) || isCard(i) || i.variant_id === PHOTOFEE || /HIDDEN/i.test(i.product_type || ''); };
  var upgradeOf = function (i) { var p = i.properties || {}, k = Object.keys(p).filter(function (k) { return /_extra_variant_id/.test(k) && p[k]; })[0]; return k ? +p[k] : 0; };
  var hasPhotoFee = function (i) { return Object.keys(i.properties || {}).some(function (k) { return /Butterfly Box Image Upload/i.test(k) && i.properties[k]; }); };
  var isAddon = function (i) { return ((window.GLV2 && GLV2.addonTypes) || []).indexOf(i.product_type) > -1; };
  var post = function (u, b) { return fetch(u, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify(b) }).then(function (r) { if (!r.ok) throw r; return r.json(); }); };
  var CART = null;
  // Box to n: its upgrade line and photo fee move by the same amount; a card stays at 1 per box line;
  // at 0 the card goes too. The gift message (cart attribute) is left alone.
  function setQty(key, n) {
    var c = CART, i = c && c.items.filter(function (x) { return x.key === key; })[0];
    if (!i) return Promise.resolve();
    var d = n - i.quantity, up = upgradeOf(i), o = post('/cart/change.js', { id: i.key, quantity: n });
    // the upgrade line: set from the cart as it is now (gl-addons.js), not moved by a delta from an older copy
    up && window.GLA && GLA.syncUpgrades && (o = o.then(function (r) { return GLA.syncUpgrades(r && r.items ? r : null); }));
    var f = hasPhotoFee(i) && c.items.filter(function (x) { return x.variant_id === PHOTOFEE; })[0];
    f && (o = o.then(function () { return post('/cart/change.js', { id: f.key, quantity: Math.max(0, f.quantity + d) }); }));
    var rs = (i.properties || {})._common_random_string;
    if (!n && rs) c.items.forEach(function (x) {
      if (x.key !== i.key && !isUpgrade(x) && (x.properties || {})._common_random_string === rs) o = o.then(function () { return post('/cart/change.js', { id: x.key, quantity: 0 }); });
    });
    return o;
  }
  // The upgrade's name as the cart page shows it: the chosen option ("Confetti", "Butterflies"), without its price
  function upName(i, upLine) {
    var p = i.properties || {}, k = Object.keys(p).filter(function (k) { return /_option_name_upgrade/.test(k) && p[k]; })[0];
    if (k) return String(p[k]).replace(/\s*\(\+\$[\d.,]+\)\s*$/, '');
    return upLine && /butterfl/i.test(upLine.variant_title || upLine.product_title || '') ? String(upLine.variant_title || 'Butterflies').replace(/\s*\(\+\$[\d.,]+\)\s*$/, '') : 'Confetti explosion';
  }
  // The printed card's message, as on the cart page
  function cardMsg(card) {
    var p = card.properties || {}, k = Object.keys(p).filter(function (k) { return /Gift Message/i.test(k) && p[k]; })[0];
    if (!k) return '';
    var m = String(p[k]);
    return '<span class="glc-line__sub glc-line__msg">&ldquo;' + esc(m.slice(0, 90)) + (m.length > 90 ? '...' : '') + '&rdquo;</span>';
  }
  // Edit: the line's own gl-v3 template (same as the cart page's edit link)
  function editUrl(i) {
    var g = window.GLV2 || {}, a = (g.tpl || {})[i.product_id], v = '';
    // launched (v3map empty): never add view= (old gl-v3-* names no longer exist)
    if (!/gl-v3/.test(a || '') && Object.keys(g.v3map || {}).length) {
      var st = {}; try { st = (window.GL2 && GL2.store && GL2.store.get('g3Tpl')) || {}; } catch (e) {}
      v = /gl-v3/.test(st[i.product_id] || '') ? st[i.product_id] : (g.v3map || {})[a || ''] || '';
    }
    return i.url + (i.url.indexOf('?') > -1 ? '&' : '?') + (v ? 'view=' + encodeURIComponent(v) + '&' : '') + 'edit=' + encodeURIComponent(i.key);
  }
  // What was chosen on a personalised line: "2 photos · 'HAPPY 30TH'" plus any other visible choices
  function chosen(i) {
    var p = i.properties || {}, photos = 0, words = '', other = [];
    Object.keys(p).forEach(function (k) {
      var v = String(p[k] == null ? '' : p[k]).trim();
      if (!v) return;
      if (/^https?:\/\//.test(v) && /upload|ucarecdn|cdn\.shopify|\.(jpe?g|png|webp|heic)/i.test(v)) photos++;
      else if (/^Personalised Message$/i.test(k)) words = v.replace(/\s*\n\s*/g, ' ');
      else if (k.charAt(0) !== '_' && v.length < 40 && !/Gift Message|^Delivery|^Checkout/i.test(k)) other.push(k.replace(/^\d+_/, '') + ': ' + v);
    });
    var bits = (photos ? [photos + (photos === 1 ? ' photo' : ' photos')] : []).concat(words ? ['‘' + words + '’'] : []).concat(other);
    return { text: bits.join(' · '), same: photos && words ? 'Same photos and words' : photos ? (photos === 1 ? 'Same photo' : 'Same photos') : words ? 'Same words' : '' };
  }
  // Undo for Remove (5 s): the exact lines that went (box, its share of the upgrade and photo fee,
  // its card) with the same properties, kept in memory until the toast goes.
  var UNDO = null;
  function snapshot(key) {
    var c = CART, i = c && c.items.filter(function (x) { return x.key === key; })[0];
    if (!i) return null;
    var items = [{ id: i.variant_id, quantity: i.quantity, properties: i.properties || {} }];
    var up = upgradeOf(i), a = up && c.items.filter(function (x) { return isUpgrade(x) && x.variant_id === up; })[0];
    a && items.push({ id: a.variant_id, quantity: i.quantity, properties: a.properties || {} });
    hasPhotoFee(i) && c.items.some(function (x) { return x.variant_id === PHOTOFEE; }) && items.push({ id: PHOTOFEE, quantity: i.quantity });
    var rs = (i.properties || {})._common_random_string;
    rs && c.items.forEach(function (x) { if (x.key !== i.key && !isUpgrade(x) && (x.properties || {})._common_random_string === rs) items.push({ id: x.variant_id, quantity: x.quantity, properties: x.properties || {} }); });
    // a gift's add-ons ("For:" it) go with it, unless another line of that gift stays
    var addons = [], keep = c.items.some(function (x) { return x.key !== i.key && x.product_id === i.product_id && !isAddon(x); });
    isAddon(i) || keep || c.items.forEach(function (x) {
      if (isAddon(x) && +(x.properties || {})._gl_for === i.product_id) { addons.push(x.key); items.push({ id: x.variant_id, quantity: x.quantity, properties: x.properties || {} }); }
    });
    return { title: i.product_title, items: items, addons: addons };
  }
  function undoAddons() {
    var n = UNDO && UNDO.addons ? UNDO.addons.length : 0;
    return n ? (n === 1 ? ' and its add-on' : ' and its ' + n + ' add-ons') : '';
  }
  function bindUndo(body) {
    var b = $('.glc-undo', body);
    if (!b || !UNDO) return;
    b.onclick = function () {
      var u = UNDO; if (!u) return;
      clearTimeout(u.t); UNDO = null; b.disabled = true; b.textContent = 'Adding back...'; track('drawer_remove_undo', {});
      post('/cart/add.js', { items: u.items }).catch(function () {})
        .then(function () { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); })
        .then(renderDrawer);
    };
  }
  // "Add to their gift" row (gl-addons.js): made once and moved back in on each redraw, so it keeps its scroll
  var AROW = null;
  var OCCS = [['birthday', 'birthday'], ['anniversary', 'anniversary'], ['valentine', 'valentine'], ['wedding', 'wedding|engage|bride'], ['baby', 'baby'], ['christmas', 'christmas|xmas|holidays'], ['mother', 'mother|mum'], ['father', 'father|dad'], ['thank', 'thank'], ['congrat', 'congrat|graduat'], ['retire', 'retire'], ['get well', 'get well']];
  var occOf = function (items) {
    var t = items.filter(function (i) { return !isAddon(i); }).map(function (i) { return i.product_title; }).join(' ').toLowerCase();
    var o = OCCS.filter(function (x) { return new RegExp(x[1]).test(t); })[0];
    return o ? o[0] : '';
  };
  function renderDrawer(cart) {
    CART = cart;
    var body = $('.glc-drawer__body', drawer);
    var main = cart.items.filter(function (i) { return !isHidden(i); });
    // Golden Month free candle (gl-candle.js): its line goes last; the card sits at the top with the add-on deal
    var GC = window.GLCD, gcard = GC ? GC.card(cart, 'drawer') : '';
    GC && (main = GC.last(main));
    var count = window.GLA ? GLA.count(cart) : main.reduce(function (a, i) { return a + i.quantity; }, 0);
    $$('.tt-badge-cart').forEach(function (b) { b.textContent = count; });
    var head = '<div class="glc-drawer__head"><span>Your cart (' + count + ')</span><button type="button" class="glc-x" data-close aria-label="Close cart">&times;</button></div>';
    if (!main.length) { body.innerHTML = head + (UNDO ? '<div class="glc-toast" role="status"><span>Removed ' + esc(UNDO.title) + undoAddons() + '.</span><button type="button" class="glc-undo">Undo</button></div>' : '') + '<p class="glc-empty">Your cart is empty.</p><a class="glc-btn glc-btn--primary" href="/collections/same-day-delivery">Shop same day delivery</a>'; bindUndo(body); return; }
    var gm = /^[A-Za-z0-9]{24}$/.test((cart.attributes || {})._gift_message || '');
    var rows = main.map(function (i, n) {
      if (GC && GC.is(i)) return GC.line(i, 'drawer');
      var up = upgradeOf(i), upLine = up && cart.items.filter(function (x) { return isUpgrade(x) && x.variant_id === up; })[0];
      var rs = (i.properties || {})._common_random_string;
      var card = rs && cart.items.filter(function (x) { return isCard(x) && x.properties._common_random_string === rs; })[0];
      var ch = chosen(i), ad = isAddon(i);
      return '<div class="glc-line" data-k="' + esc(i.key) + '"><a href="' + esc(i.url) + '" class="glc-line__img">' + (i.image ? '<img src="' + esc(i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=200') + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="glc-line__info"><div class="glc-line__top"><a href="' + esc(i.url) + '" class="glc-line__title">' + esc(i.product_title) + '</a><b class="glc-line__price">' + (i.line_level_total_discount > 0 ? '<s>' + money(i.original_line_price) + '</s> ' : '') + money(i.final_line_price) + '</b></div>' +
        (i.variant_title && i.variant_title !== i.product_title && !/^default/i.test(i.variant_title) ? '<span class="glc-line__sub">' + esc(i.variant_title) + '</span>' : '') +
        (ch.text ? '<span class="glc-line__sub">' + esc(ch.text) + '</span>' : '') +
        (ad && window.GLA && GLA.forTitle(i, cart) ? '<span class="glc-line__sub glc-line__for">For: ' + esc(GLA.forTitle(i, cart)) + '</span>' : '') +
        // an add-on no gift here can take (e.g. a box sleeve with only butterfly boxes)
        (ad && window.GLA && GLA.misfit(i, cart) ? '<span class="glc-line__sub gla-misfit">' + esc(GLA.misfit(i, cart)) + '</span>' : '') +
        (up ? '<span class="glc-line__sub glc-line__conf">&#10003; ' + esc(upName(i, upLine)) + (upLine ? ' +' + money(upLine.price * i.quantity) : '') + '</span>' : '') +
        (hasPhotoFee(i) ? '<span class="glc-line__sub glc-line__conf">&#10003; 4x photos +' + money(((cart.items.filter(function (x) { return x.variant_id === PHOTOFEE; })[0] || {}).price || 2000) * i.quantity) + '</span>' : '') +
        (card ? '<span class="glc-line__sub glc-line__conf">&#10003; ' + esc(card.variant_title && !/default/i.test(card.variant_title) ? card.variant_title : card.product_title) + ' +' + money(card.final_line_price) + '</span>' + cardMsg(card) : '') +
        (gm && !n ? '<span class="glc-line__sub glc-line__conf">&#10003; Digital gift message added</span>' : '') +
        '<div class="glc-line__act"><span class="glc-q"><button type="button" data-d="-1" aria-label="One fewer ' + esc(i.product_title) + '">&minus;</button><b>' + i.quantity + '</b><button type="button" data-d="1" aria-label="One more ' + esc(i.product_title) + '">+</button></span>' +
        (ad ? '' : '<a class="glc-lnk" href="' + esc(editUrl(i)) + '">Edit</a>') +
        '<button type="button" class="glc-lnk" data-rm>Remove</button></div>' +
        (ch.same ? '<span class="glc-line__same">' + ch.same + '</span>' : '') +
        '</div></div>';
    }).join('');
    var a = cart.attributes || {};
    var hasDate = !!a['Delivery-Date'];
    var deliv = hasDate
      ? '<div class="glc-box"><div class="glc-row"><b>' + (a['Checkout-Method'] === 'pickup' ? 'Pickup' : 'Delivery') + (a['Delivery-Postcode'] ? ' · ' + esc(a['Delivery-Postcode']) : '') + '</b><a href="' + esc(cartUrl()) + '">Change</a></div><div class="glc-row"><span>' + esc(fmtDate(a['Delivery-Date'])) + '</span></div></div>'
      : '';
    // same row as the v3 cart page; opens the Multi Order modal
    var multi = '<button type="button" class="glc-mrow"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="9" cy="8" r="3.5"/><path d="M2.5 20c.8-3.6 3.4-5.5 6.5-5.5s5.7 1.9 6.5 5.5M16 4.8a3.5 3.5 0 010 6.4M18.5 14.8c1.6.8 2.7 2.5 3 5.2"/></svg><span><b>Sending to more than one person?</b><em>Split this order across addresses</em></span><i class="glc-sw" aria-hidden="true"></i></button>';
    var saved = window.GLA ? GLA.saved(cart) : 0;
    var asl = AROW && AROW.el.querySelector('.gla-row'), ascroll = asl ? asl.scrollLeft : 0;
    var sub = cart.total_price - cart.items.reduce(function (t, i) { return t + (isGuarantee(i) ? i.final_line_price : 0); }, 0);
    var extrasUrl = cartUrl() + (isMobile() ? (cartUrl().indexOf('?') > -1 ? '&' : '?') + 'step=extras' : '');
    body.classList.toggle('glcd-on', !!gcard);
    body.innerHTML = head + gcard +
      (UNDO ? '<div class="glc-toast" role="status"><span>Removed ' + esc(UNDO.title) + undoAddons() + '.</span><button type="button" class="glc-undo">Undo</button></div>' : '') +
      '<div class="glc-lines">' + rows + '</div>' +
      (window.GLA ? '<div class="glc-aslot"></div>' : '') +
      '<a class="glc-more" href="' + esc(extrasUrl) + '">See all add-ons &rarr;</a>' +
      multi + deliv +
      '<div class="glc-drawer__foot">' + (saved > 0 ? '<div class="glc-row glc-deal"><span>Add-on deal</span><b>&minus;' + money(saved) + '</b></div>' : '') + '<div class="glc-row glc-row--total"><span>Subtotal</span><b>' + money(sub) + '</b></div>' +
      '<p class="glc-note">' + (hasDate ? 'Delivery fee and order protection are added on the next step.' : 'Choose delivery or pickup and your date on the next step.') + '</p>' +
      '<a class="glc-btn glc-btn--primary" href="' + esc(cartUrl()) + '">Checkout</a>' +
      '<div class="glc-keeprow"><button type="button" class="glc-keep" data-close>Keep shopping</button><button type="button" class="g3-help" data-glh aria-label="Help" aria-expanded="false"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 5h11a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H9l-4 3v-3H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z"/><path d="M17 9h3a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-1v3l-4-3h-3"/></svg><span>Help</span></button></div></div>';
    var busy = false, run = function (key, n, ev) {
      if (busy) return; busy = true; body.classList.add('glc-busy'); track(ev, { qty: n });
      var snap = n === 0 ? snapshot(key) : null;
      if (snap) {
        UNDO && clearTimeout(UNDO.t);
        UNDO = snap;
      }
      // the 5 s start once the drawer shows the toast, not on tap (removing takes a moment)
      var startUndo = function () {
        snap && UNDO === snap && (snap.t = setTimeout(function () { if (UNDO === snap) { UNDO = null; var t = $('.glc-toast', drawer); t && t.remove(); } }, 5000));
      };
      (snap ? snap.addons : []).reduce(function (o, k) { return o.then(function () { return post('/cart/change.js', { id: k, quantity: 0 }); }); }, Promise.resolve())
        .then(function () { return setQty(key, n); }).catch(function () {}).then(function () { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); })
        .then(function (c) { busy = false; body.classList.remove('glc-busy'); renderDrawer(c); startUndo(); })
        .catch(function () { busy = false; body.classList.remove('glc-busy'); });
    };
    $$('.glc-line', body).forEach(function (l) {
      var k = l.getAttribute('data-k'), it = main.filter(function (x) { return x.key === k; })[0];
      $$('.glc-q button', l).forEach(function (b) { b.onclick = function () { run(k, Math.max(0, it.quantity + +b.getAttribute('data-d')), 'drawer_qty'); }; });
      var rm = $('[data-rm]', l);
      rm && (rm.onclick = function () { run(k, 0, 'drawer_remove'); });
    });
    bindUndo(body);
    var slot = $('.glc-aslot', body);
    if (slot) {
      if (!AROW) AROW = GLA.row({ surface: 'drawer-addons', hideScope: 'cart', forId: function (c) { var g = GLA.giftOf(c); return g && g.id; }, smartFor: function (c) { return GLA.giftRefs(c); }, occ: occOf(main), compact: true, limit: 10, cart: cart, onChange: renderDrawer });
      else AROW.sync(cart);
      slot.parentNode.replaceChild(AROW.el, slot);
      asl && (asl.scrollLeft = ascroll);
    }
    var mr = $('.glc-mrow', body);
    mr && (mr.onclick = function () {
      track('drawer_multi_open', {});
      // close the drawer first so the modal is the only thing on screen; closing it leaves the page as it was
      closeDrawer();
      if (window.MultiAddress && MultiAddress.open) return MultiAddress.open({ fromProduct: false, source: 'drawer' });
      var a = $('.ma-cart-nudge-cta') || $('.ma-product-link a');
      if (a) return a.click();
      location.href = CFG.corporateUrl;
    });
  }
  // gl-candle.js redraws the open drawer after it adds, swaps or removes the candle
  window.GLCRO_DR = { render: function (c) { if (drawer && drawer.classList.contains('glc-drawer--open') && c && c.items && !$('.glc-drawer__body', drawer).classList.contains('glc-busy')) renderDrawer(c); } };
  // The header cart icon never opens the theme's old mini-cart (also hidden in gl-cro.css): it opens
  // this drawer, or on the cart page scrolls up to the order.
  function initDrawer() {
    var cartPage = CFG.template === 'cart';
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('.tt-cart .tt-dropdown-toggle, .tt-mobile-parent-cart .tt-dropdown-toggle, .tt-stuck-parent-cart .tt-dropdown-toggle');
      if (!t) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (!cartPage) return openDrawer();
      var o = document.querySelector('.g3c') || document.querySelector('.main-cart-page, .tt-empty-cart');
      window.scrollTo(0, o ? Math.max(0, o.getBoundingClientRect().top + window.scrollY - 90) : 0);
    }, true);
    cartPage || document.documentElement.classList.add('glc-has-drawer');
  }

  /* ---------------- Cart page ---------------- */
  function initCartPage() {
    // Fix: "Add More to Your Gift" had href="#", which made the theme's smooth-scroll script throw on first click
    var add = $('.addons-popp');
    if (add) {
      var anchor = document.createElement('span'); anchor.id = 'glc-addmore'; add.parentNode.insertBefore(anchor, add);
      add.setAttribute('href', '#glc-addmore');
      add.classList.add('glc-outline');
    }
    // Express checkout: only after delivery method and date are confirmed
    var express = $('.additional_checkout_buttons');
    var target = $('#proceedtoShipping');
    var wrap = document.createElement('div');
    wrap.className = 'glc-express';
    wrap.innerHTML = '<p class="glc-express__label">Or check out faster with</p>';
    if (express && target) { target.appendChild(wrap); wrap.appendChild(express); }
    var lastHasDate = null;
    function check() {
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        var a = c.attributes || {};
        var ok = !!(a['Delivery-Date'] && a['Checkout-Method']);
        if (ok === lastHasDate) return; lastHasDate = ok;
        if (express) { express.classList.toggle('hide', !ok); wrap.classList.toggle('glc-express--show', ok); }
        var sb = $('.glc-cartbar__btn'); if (sb) sb.textContent = ok ? 'Checkout' : 'Choose delivery date';
      }).catch(function () {});
    }
    check();
    var pickup = $('#storePickupApp');
    if (pickup) pickup.addEventListener('click', function () { setTimeout(check, 1200); setTimeout(check, 3000); });
    // Mobile sticky bar
    var totalEl = $('#grandtotal td') || $('.tt-shopcart-table01 tfoot td');
    var bar = document.createElement('div');
    bar.className = 'glc-cartbar';
    bar.innerHTML = '<span class="glc-cartbar__total">' + (totalEl ? esc(totalEl.textContent.trim()) : '') + '</span><button type="button" class="glc-cartbar__btn">Choose delivery date</button>';
    document.body.appendChild(bar);
    bar.querySelector('button').addEventListener('click', function () {
      var btn = $$('#proceedtoShipping button, #proceedtoShipping a').filter(function (b) { return visible(b) && /checkout/i.test(b.textContent); })[0];
      if (lastHasDate && btn) { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      else if (target) { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { bar.classList.toggle('glc-cartbar--show', !en[0].isIntersecting && isMobile()); }, { threshold: 0.15 }).observe(target);
    }
    if (location.hash === '#proceedtoShipping' && target) setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 500);
  }

  /* ---------------- Chat greeting: keep the button, drop the bubble on mobile product and cart pages ---------------- */
  function quietChat() {
    if (!isMobile() || (CFG.template !== 'product' && CFG.template !== 'cart')) return;
    var n = 0, t = setInterval(function () {
      var p = document.getElementById('coax-widget-text');
      if (p) {
        var bubble = p.parentElement;
        for (var i = 0; i < 3 && bubble && bubble.parentElement; i++) {
          if (/text us/i.test(bubble.parentElement.textContent)) break;
          bubble = bubble.parentElement;
        }
        if (bubble && !/text us/i.test(bubble.textContent)) bubble.style.display = 'none';
        clearInterval(t);
      }
      if (++n > 40) clearInterval(t);
    }, 500);
  }

  /* ---------------- Help (Just Right Help embed) from our bars ----------------
     On gl-v3 pages with a bottom bar, Help is a button in the bar ([data-glh]); it presses the embed's own
     Help button. Opening waits a tick: the embed closes itself on any click outside it. */
  function initHelp() {
    var n = 0, t = setInterval(function () {
      var root = document.getElementById('glh');
      if (root && root.querySelector('.glh-fab')) {
        clearInterval(t); document.documentElement.classList.add('glh-on');
        var sync = function () { var o = root.classList.contains('open'); $$('[data-glh]').forEach(function (b) { b.setAttribute('aria-expanded', String(o)); }); };
        window.MutationObserver && new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['class'] });
      } else if (++n > 60) clearInterval(t);
    }, 500);
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-glh]');
      if (!b) return;
      var root = document.getElementById('glh'), fab = root && root.querySelector('.glh-fab');
      if (!fab) return;
      if (!root.classList.contains('open')) { track('help_open_bar', {}); setTimeout(function () { fab.click(); }, 0); }
    });
  }
  function boot() {
    try { initHelp(); } catch (e) {}
    // launch: product extras only on the v3 templates (other products keep today's page)
    try { if (CFG.template === 'product' && CFG.pdp !== false) initProduct(); } catch (e) { console.warn('glc product', e); }
    try { initDrawer(); } catch (e) { console.warn('glc drawer', e); }
    try { if (CFG.template === 'cart') initCartPage(); } catch (e) { console.warn('glc cart', e); }
    try { quietChat(); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
